// extracted by mini-css-extract-plugin
export default {"button":"wZATbmaU-kMdWbf+1GzAeA==","icon":"A1XuWueLWsaY05pgs29C2A=="};